// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const HEADER_BAR_HEIGHT = 64;
export const AGENCY_DASHBOARD_HEADER_BAR_HEIGHT = 88;
export const TABLET_WIDTH = 834;
export const COMMON_DESKTOP_WIDTH = 1366;
export const PANEL_RIGHT_TOP_BUTTONS_CONTAINER_HEIGHT = 56;
export const PANEL_LEFT_CONTAINER_MAX_WIDTH = 400;
export const FOOTER_HEIGHT_WITHOUT_MARGIN = 64;
export const FOOTER_HEIGHT_WITH_MARGIN = FOOTER_HEIGHT_WITHOUT_MARGIN + 60;

export const MIN_MOBILE_WIDTH = 512;
export const MIN_TABLET_WIDTH = 860;
export const MIN_DESKTOP_WIDTH = 1200;

export const MAIN_PANEL_WIDTH = 676;
